import React from 'react';
import Grid from '@material-ui/core/Grid';
import { useSelector, useDispatch } from 'react-redux';
import { selectButton, pushShowRelatedDta, selectedRelatedEntity, selectedRelatedDataButton, pushEnableClearAll, pushIsSaveDisabled, pushRunSelected, pushPostApiResponse, pushTableData } from '../../slices/customQueryHeaderSlice';
import { deleteChipArrayAddCriteria, pushShowCard, pushShowTable, pushCheckTableData } from '../../slices/customQueryBodySlice';
import { StyledLabel, StyledLabelGrid, ContainerGrid } from './DataTypeButtonStyle';
import StyledPill from '../../components/StyledPill/StyledPill';
import StyledPillContainer from '../../components/StyledPillContainer/StyledPillContainer';
import { pushSavedQueryName } from '../../slices/QueriesManagerSlice';

const DataTypeButtonNames = () => {
  const dataTypeButtonNames = useSelector(state => state.customQueryHeader.buttonsNamesArray);
  const contextualPath = useSelector(state => state.customQueryHeader.showPath);
  const queryData = useSelector(state => state.queriesManager.queryData);
  const queryName = useSelector(state => state.queriesManager.queryName);
  const selectedEntity = useSelector(state => state.customQueryHeader.selectedDataType);
  const dispatch = useDispatch();

  const handleEntityButtonClick = (event, dataTypeButtonName) => {
    dispatch(pushRunSelected(false));
    dispatch(pushShowCard(false));
    dispatch(pushShowTable(false));
    dispatch(selectedRelatedDataButton([]));
    dispatch(selectedRelatedEntity([]));
    const selectedBtn = {
      selectedName: event.target.innerText,
      selectedRelatedEntity: dataTypeButtonName.relatedEntity
    };
    let data = {
      data: '',
      type: 'run'
    };
    dispatch(pushPostApiResponse(data));
    let savedata = {
      data: '',
      type: 'save'
    };
    dispatch(pushPostApiResponse(savedata));
    let queryResults = {
      data: [],
      totalCount: 0,
      totalPages: 0
    };
    dispatch(pushTableData(queryResults));
    dispatch(selectButton(selectedBtn));
    dispatch(pushShowRelatedDta(true));
    dispatch(pushCheckTableData(false));
    dispatch(selectedRelatedEntity(dataTypeButtonName.relatedEntity));
    dispatch(deleteChipArrayAddCriteria([]));
    dispatch(pushEnableClearAll(false));

    if (queryData.length == 0) {
      dispatch(pushSavedQueryName(queryName));
      dispatch(pushIsSaveDisabled(true));
    } else {
      dispatch(pushIsSaveDisabled(false));
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ContainerGrid, {
    container: true
  }, /*#__PURE__*/React.createElement(StyledLabelGrid, {
    item: true
  }, /*#__PURE__*/React.createElement(StyledLabel, null, "Entity ")), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(StyledPillContainer, {
    exclusive: true
  }, contextualPath ? /*#__PURE__*/React.createElement(StyledPill, {
    name: selectedEntity,
    "aria-label": selectedEntity,
    variant: "contained",
    color: "primary",
    selected: true,
    value: selectedEntity
  }, selectedEntity) : /*#__PURE__*/React.createElement(React.Fragment, null, dataTypeButtonNames.map((dataTypeButtonName, index) => {
    return /*#__PURE__*/React.createElement(StyledPill, {
      key: index,
      name: dataTypeButtonName.name,
      "aria-label": dataTypeButtonName.name,
      variant: dataTypeButtonName.variant,
      value: dataTypeButtonName.name,
      onClick: e => handleEntityButtonClick(e, dataTypeButtonName),
      selected: dataTypeButtonName.name === selectedEntity
    }, dataTypeButtonName.name);
  }))))));
};

export default DataTypeButtonNames;